/* tslint:disable */
/* eslint-disable */
/**
 * Hyper GES API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ComuneDTO,
  NazioneDTO,
  ProblemDetails,
  ProvinciaDTO,
  RegioneDTO,
  RoleDTO,
} from '../models/index';
import {
    ComuneDTOFromJSON,
    ComuneDTOToJSON,
    NazioneDTOFromJSON,
    NazioneDTOToJSON,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
    ProvinciaDTOFromJSON,
    ProvinciaDTOToJSON,
    RegioneDTOFromJSON,
    RegioneDTOToJSON,
    RoleDTOFromJSON,
    RoleDTOToJSON,
} from '../models/index';

export interface GetComuneByIdRequest {
    comuneId: string;
}

export interface GetComuniRequest {
    nazioneId?: string;
    regioneId?: string;
    provinciaId?: string;
}

export interface GetNazioneByIdRequest {
    nazioneId: string;
}

export interface GetProvinceRequest {
    nazioneId?: string;
    regioneId?: string;
}

export interface GetProvinciaByIdRequest {
    provinciaId: string;
}

export interface GetRegioneByIdRequest {
    regioneId: string;
}

export interface GetRegioniRequest {
    nazioneId?: string;
}

export interface GetRoleByIdRequest {
    roleId: string;
}

export interface GetRolesRequest {
    withVirtualRoles?: boolean;
}

/**
 * 
 */
export class AnagraficheComuniApi extends runtime.BaseAPI {

    /**
     */
    async getComuneByIdRaw(requestParameters: GetComuneByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ComuneDTO>> {
        if (requestParameters['comuneId'] == null) {
            throw new runtime.RequiredError(
                'comuneId',
                'Required parameter "comuneId" was null or undefined when calling getComuneById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/Comuni/{comuneId}`.replace(`{${"comuneId"}}`, encodeURIComponent(String(requestParameters['comuneId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ComuneDTOFromJSON(jsonValue));
    }

    /**
     */
    async getComuneById(requestParameters: GetComuneByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ComuneDTO> {
        const response = await this.getComuneByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getComuniRaw(requestParameters: GetComuniRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ComuneDTO>>> {
        const queryParameters: any = {};

        if (requestParameters['nazioneId'] != null) {
            queryParameters['nazioneId'] = requestParameters['nazioneId'];
        }

        if (requestParameters['regioneId'] != null) {
            queryParameters['regioneId'] = requestParameters['regioneId'];
        }

        if (requestParameters['provinciaId'] != null) {
            queryParameters['provinciaId'] = requestParameters['provinciaId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/Comuni`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ComuneDTOFromJSON));
    }

    /**
     */
    async getComuni(requestParameters: GetComuniRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ComuneDTO>> {
        const response = await this.getComuniRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getNazioneByIdRaw(requestParameters: GetNazioneByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<NazioneDTO>> {
        if (requestParameters['nazioneId'] == null) {
            throw new runtime.RequiredError(
                'nazioneId',
                'Required parameter "nazioneId" was null or undefined when calling getNazioneById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/Nazioni/{nazioneId}`.replace(`{${"nazioneId"}}`, encodeURIComponent(String(requestParameters['nazioneId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => NazioneDTOFromJSON(jsonValue));
    }

    /**
     */
    async getNazioneById(requestParameters: GetNazioneByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<NazioneDTO> {
        const response = await this.getNazioneByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getNazioniRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<NazioneDTO>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/Nazioni`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(NazioneDTOFromJSON));
    }

    /**
     */
    async getNazioni(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<NazioneDTO>> {
        const response = await this.getNazioniRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getProvinceRaw(requestParameters: GetProvinceRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ProvinciaDTO>>> {
        const queryParameters: any = {};

        if (requestParameters['nazioneId'] != null) {
            queryParameters['nazioneId'] = requestParameters['nazioneId'];
        }

        if (requestParameters['regioneId'] != null) {
            queryParameters['regioneId'] = requestParameters['regioneId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/Province`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ProvinciaDTOFromJSON));
    }

    /**
     */
    async getProvince(requestParameters: GetProvinceRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ProvinciaDTO>> {
        const response = await this.getProvinceRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getProvinciaByIdRaw(requestParameters: GetProvinciaByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProvinciaDTO>> {
        if (requestParameters['provinciaId'] == null) {
            throw new runtime.RequiredError(
                'provinciaId',
                'Required parameter "provinciaId" was null or undefined when calling getProvinciaById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/Province/{provinciaId}`.replace(`{${"provinciaId"}}`, encodeURIComponent(String(requestParameters['provinciaId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProvinciaDTOFromJSON(jsonValue));
    }

    /**
     */
    async getProvinciaById(requestParameters: GetProvinciaByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProvinciaDTO> {
        const response = await this.getProvinciaByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getRegioneByIdRaw(requestParameters: GetRegioneByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RegioneDTO>> {
        if (requestParameters['regioneId'] == null) {
            throw new runtime.RequiredError(
                'regioneId',
                'Required parameter "regioneId" was null or undefined when calling getRegioneById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/Regioni/{regioneId}`.replace(`{${"regioneId"}}`, encodeURIComponent(String(requestParameters['regioneId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RegioneDTOFromJSON(jsonValue));
    }

    /**
     */
    async getRegioneById(requestParameters: GetRegioneByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RegioneDTO> {
        const response = await this.getRegioneByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getRegioniRaw(requestParameters: GetRegioniRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<RegioneDTO>>> {
        const queryParameters: any = {};

        if (requestParameters['nazioneId'] != null) {
            queryParameters['nazioneId'] = requestParameters['nazioneId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/Regioni`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(RegioneDTOFromJSON));
    }

    /**
     */
    async getRegioni(requestParameters: GetRegioniRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<RegioneDTO>> {
        const response = await this.getRegioniRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getRoleByIdRaw(requestParameters: GetRoleByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RoleDTO>> {
        if (requestParameters['roleId'] == null) {
            throw new runtime.RequiredError(
                'roleId',
                'Required parameter "roleId" was null or undefined when calling getRoleById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/Roles/{roleId}`.replace(`{${"roleId"}}`, encodeURIComponent(String(requestParameters['roleId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RoleDTOFromJSON(jsonValue));
    }

    /**
     */
    async getRoleById(requestParameters: GetRoleByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RoleDTO> {
        const response = await this.getRoleByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getRolesRaw(requestParameters: GetRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<RoleDTO>>> {
        const queryParameters: any = {};

        if (requestParameters['withVirtualRoles'] != null) {
            queryParameters['withVirtualRoles'] = requestParameters['withVirtualRoles'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/Roles`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(RoleDTOFromJSON));
    }

    /**
     */
    async getRoles(requestParameters: GetRolesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<RoleDTO>> {
        const response = await this.getRolesRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
